"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PriceAddons = _ref => {
  let {
    prefix,
    children,
    className
  } = _ref;
  if (!children || children.length === 0) return null;
  return _react.default.createElement("div", {
    className: `${prefix}price-module__addons`
  }, _react.default.Children.toArray(children).map((child, i) => _react.default.createElement("div", {
    key: i,
    className: `${prefix}price-module__addon`
  }, child)));
};
PriceAddons.defaultProps = {
  prefix: ''
};
var _default = PriceAddons;
exports.default = _default;